let schedule = $('.schedule');

if(schedule.length) {

    let scheduleDateToggle = $('.date-selection-display'),
        scheduleDateMenu = $('.date-selection-menu-dropdown'),
        scheduleDateItems = $('.date-selection-menu-item');

    scheduleDateToggle.on('click', function () {
        if(scheduleDateMenu.hasClass('active')) {
            scheduleDateMenu.removeClass('active');
            scheduleDateToggle.removeClass('open');
        } else {
            scheduleDateMenu.addClass('active');
            scheduleDateToggle.addClass('open');
        }
    });

    scheduleDateItems.on('click', function () {

        let dateIndex = $(this).data('date-index'),
            dateText = $(this).text();

        scheduleDateToggle.find('span').text(dateText);
        scheduleDateMenu.removeClass('active');
        scheduleDateToggle.removeClass('open');

        changeDate(dateIndex);

    });

    function changeDate(dateIndex) {

        $('.schedule-date').not('.schedule-date-' + dateIndex).hide();
        $('.schedule-date-' + dateIndex).show();

    }

}
